import { Link } from 'react-router-dom';
import { feedItems } from '@/mocks/feed';
import FeedCard from '@/components/feature/FeedCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function LatestFeed() {
  const latest = feedItems.slice(0, 6);

  return (
    <section className="border-y border-background-200/70 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="Latest Bulletins"
          title="最新瓜报，按出现顺序排好"
          desc="每一条都标了出现时间、所属栏目和值夜编辑，方便你对照着往下看事情的推进过程。"
          action={
            <Link
              to="/feed"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-500/50 hover:text-primary-300"
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((item) => (
            <FeedCard key={item.slug} item={item} showHeat />
          ))}
        </div>
      </div>
    </section>
  );
}